import { defineComponent as _defineComponent } from 'vue'
import { ProductConfiguratorMultiColorProperty, store } from '@/store';
import TrackingService from '@/core/tracking.service';
import ProfessionalVariantViewObject = Vertica.LouisPoulsen.Application.Content.Pages.Product.ProfessionalVariantViewObject;
import MultiColorViewObject = Vertica.LouisPoulsen.Application.Content.Pages.Product.MultiColorViewObject;
import { computed } from 'vue';
import { useTranslations } from '@/core/translate.mixin';


export default /*#__PURE__*/_defineComponent({
  __name: 'ProductVariantList',
  props: {
    variants: null,
    columns: null,
    scrollMode: { type: Boolean }
  },
  emits: ["rowSelected"],
  setup(__props: any, { emit }: { emit: ({(e: 'rowSelected') : void}), expose: any, slots: any, attrs: any }) {





const theme = computed<ColorTheme>(() => store.getters['app/theme']);

function selectVariantConfig(variant: VariantBaseViewObject, pushToHistory?: boolean) {
    store.dispatch('catalog/selectVariantConfig', { variant, pushToHistory });
}
function toggleShowVariantDataSpecs(flag: boolean) : void {
    store.dispatch('catalog/toggleShowVariantDataSpecs', flag);
}
const gaTrackingGoal = computed<string>(() => store.getters['catalog/gaTrackingGoal']);

const { t } = useTranslations();

function getColumnValue(type:string, value:string | MultiColorViewObject[]) {
    if (type === ProductConfiguratorMultiColorProperty) {
        return value.length > 1 ? t('Pages.ProductDetail.ProductVariantPicker.IsMultiColorLabel') : (value[0] as MultiColorViewObject).text;
    } else {
        return value;
    }
}

function selectVariant(variant:ProfessionalVariantViewObject) {
    selectVariantConfig(variant, true);
    toggleShowVariantDataSpecs(true);
    emit('rowSelected');
    TrackingService.event('Ecommerce', gaTrackingGoal.value, 'Select variant - variant list');
}

return { __sfc: true,emit, theme, selectVariantConfig, toggleShowVariantDataSpecs, gaTrackingGoal, t, getColumnValue, selectVariant }
}

})